var _path, _path2, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4746 6.19668L16.303 9.02511L8.04184 17.2863C7.90788 17.4203 7.73862 17.5134 7.55377 17.5549L5.73018 17.9643C5.01419 18.125 4.37469 17.4855 4.53542 16.7695L4.9448 14.946C4.9863 14.7611 5.07945 14.5918 5.21341 14.4579L13.4746 6.19668Z",
    stroke: "#303C54",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5956 2.66128C16.3766 1.88024 17.6429 1.88024 18.424 2.66128L19.8382 4.0755C20.6192 4.85655 20.6192 6.12288 19.8382 6.90392L19.1311 7.61103L14.8884 3.36839L15.5956 2.66128Z",
    fill: "#303C54"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 21,
    width: 18,
    height: 2,
    rx: 1,
    fill: "#303C54"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.fc76dd706803038b3bdca05c30d4cff3.svg";
export { ForwardRef as ReactComponent };